<template>
  <login-layout :title="layoutTit">
    <div class="invite-login-tit">
      {{ $t('message["638"]') }}
    </div>
    <div class="accout-login invite-login">
      <a-form
        :form="form"
        @submit.prevent="submitForm"
      >
        <a-form-item
          label=""
        >
          <a-popover
            title=""
            trigger="focus"
            overlay-class-name="input-tip-tip-box"
            :arrow-point-at-center="true"
            :destroy-tooltip-on-hide="true"
          >
            <template slot="content">
              <p>3-15{{ $t('message["369"]') }}</p>
            </template>
            <a-input
              v-decorator="decorators.username"
              :placeholder="setAccountPlace"
            />
          </a-popover>
        </a-form-item>
        <a-form-item
          label=""
        >
          <a-popover
            title=""
            trigger="focus"
            overlay-class-name="input-tip-tip-box"
            :arrow-point-at-center="true"
            :destroy-tooltip-on-hide="true"
          >
            <template slot="content">
              <p>{{ $t('message["633"]') }}</p>
            </template>
            <a-input
              v-decorator="decorators.password"
              :placeholder="setPwdPlace"
              type="password"
            />
          </a-popover>
        </a-form-item>
        <a-form-item
          label=""
        >
          <a-popover
            title=""
            trigger="focus"
            overlay-class-name="input-tip-tip-box"
            :arrow-point-at-center="true"
            :destroy-tooltip-on-hide="true"
          >
            <template slot="content">
              <p>2-15{{ $t('message["368"]') }}</p>
            </template>
            <a-input
              v-decorator="decorators.truename"
              :placeholder="setTruenamePlace"
            />
          </a-popover>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1052"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <p class="reg-login-btn">
      {{ $t('message["1482"]') }}， <router-link :to="{name: 'AccountLogin'}">
        {{ $t('message["901"]') }}
      </router-link>
    </p>
  </login-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import LoginLayout from '@/components/pc/account/LoginLayout'
import { setAuth } from '@/lib/storage'
export default {
  'name': 'RegSetUser',
  components: {
    LoginLayout
  },
  data () {
    return {
      inviteLogin: {
        mobile: this.$route.query.mobile,
        ensecret: this.$route.query.ensecret
      }
    }
  },
  computed: {
    ...mapState('account/register', ['decorators']),
    setAccountPlace () {
      return this.$t('message["1015"]')
    },
    setPwdPlace () {
      return this.$t('message["1028"]')
    },
    setTruenamePlace () {
      return this.$t('message["1029"]')
    },
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/register', ['ajaxRegSecond']),
    submitForm (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, this.inviteLogin)
          const chain = await this.ajaxRegSecond()
          chain.params(obj)
            .onSuccess(raw => {
              setAuth(raw.Authorization)
              this.$store.commit('setAuth', raw.Authorization, { root: true })
              this.$router.push({ name: 'AccountInfo' })
            })
            .onNetSuccess((res) => {
              if (res.data.error) {
                this.$message.warning(res.data.message || res.data.payload[0].message)
              }
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped >
.invite-login-tit {
  height: 24px;
  line-height: 24px;
  padding: 8px 0;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;

  span {
    margin: 0 10px;
  }
}

.invite-login {
  padding-top: 30px;

  .login-btn {
    display: block;
    width: 100%;
  }
}

.reg-login-btn {
  text-align: center;
}
</style>
